import IssueTypeBucket from './index';
const meta = {
    title: 'Features/IIMReview/IssueTypeBucket',
    component: IssueTypeBucket,
    parameters: {
        layout: 'padded'
    },
    args: {
        bucketKey: 'finish_inspection',
        count: 5,
        totalCount: 12
    }
};
export default meta;
export const Default = {};
export const ResolveBuilding = {
    args: {
        bucketKey: 'resolve_building_issues',
        count: 3,
        totalCount: 12
    }
};
export const VerifyData = {
    args: {
        bucketKey: 'verify_inspection_data',
        count: 1,
        totalCount: 12
    }
};
export const CheckCompanyRules = {
    args: {
        bucketKey: 'check_company_rules',
        count: 2,
        totalCount: 12
    }
};
